import React, { useState, useEffect, useRef } from "react";
import {
  ChevronLeft,
  ChevronRight,
  GraduationCap,
  MessageCircle,
  Users,
  Camera,
  Instagram,
  ExternalLink,
  Sparkles,
} from "lucide-react";
import Seo from "../components/Seo";

// Asset imports
import onboard1 from "../img/onboard1.webp";
import onboard2 from "../img/onboard2.webp";
import onboard3 from "../img/onboard3.webp";
import onboard4 from "../img/onboard4.webp";
import onboard5 from "../img/onboard5.webp";
import onboard6 from "../img/onboard6.webp";
import onboard7 from "../img/onboard7.webp";
import onboard8 from "../img/onboard8.webp";
import onboard9 from "../img/ob9.webp";
import onboard10 from "../img/ob10.webp";
import onboard11 from "../img/ob11.webp";
import onboard12 from "../img/ob12.webp";
import capt from "../img/capt.webp";
import bv from "../img/bv.jpeg";
import kp from "../img/kp.webp";
import kr from "../img/kr.webp";
import kj from "../img/kj.webp";
import be from "../img/be.webp";
import bsi from "../img/bsi.webp";
import bul from "../img/bulia.webp";
import al from "../img/aliefta.webp";
import yud from "../img/yudha.webp";
import breis from "../img/breis.webp";
import allTeamPhoto from "../img/team.webp";
import backgroundImageHeader from "../img/image.png";

const managementTeam = {
  tier1: [
    {
      role: "Owner & Founder",
      name: "Capt. Makkama Patontonan",
      education: "Banten Maritime Polytechnic, Indonesia",
      wa: "6281383730788",
      avatar: capt,
      quote:
        "We are committed to developing maritime professionals who are disciplined, competent, and ready to face global challenges, because we believe that the progress of the maritime industry begins with improving the quality of the people who drive it.",
    },
  ],
  tier2: [
    {
      role: "Crewing Manager",
      name: "Vivi Savitri, S.Pd., M.Pd.",
      education:
        "Master of English Education, Syarif Hidayatullah State Islamic University Jakarta, Indonesia",
      wa: "6281388094327",
      avatar: bv,
      quote:
        "Success is built on consistency, discipline, and the courage to keep going.",
    },
  ],
  tier3: [
    {
      role: "Crewing",
      name: "Putri Naflah Tabitah Mth, S.Pd.",
      education:
        "English Education - State Islamic University of Palopo, Indonesia",
      wa: "6282298455490",
      avatar: kp,
      quote: "A winner is a dreamer who never gives up.",
    },
    {
      role: "Crewing",
      name: "Riska, S.Pd.",
      education:
        "English Education - State Islamic University of Palopo, Indonesia",
      wa: "6287848055516",
      avatar: kr,
      quote: "The future belongs to the relentless.",
    },
    {
      role: "Crewing",
      name: "Jasmin B. Saijeng, S.Pd.",
      education:
        "English Education - State Islamic University of Palopo, Indonesia",
      wa: "6285757632809",
      avatar: kj,
      quote: "Nothing is a Coincidence, Everything Happens for a Reason.",
    },
    {
      role: "Crewing",
      name: "Silmi Atma Ayu, S.Pd.",
      education:
        "English Education - State Islamic University of Palopo, Indonesia",
      wa: "6282260580449",
      avatar: bsi,
      quote:
        "Success is the sum of small efforts, repeated day in and day out.",
    },
    {
      role: "Crewing",
      name: "Rezha Afrida Yanti, S.Tr.Pel.",
      education: "Merchant Marine Polytechnic of Makassar, Indonesia",
      wa: "6282299333345",
      avatar: be,
      quote: "Don't stop when you're tired, stop when you're finished.",
    },
  ],
  tier4: [
    {
      role: "Crewing Staff",
      name: "Yudha Nur Apriansyah",
      education: "State Vocational High School 21 Jakarta, Indonesia",
      wa: "6285111358698",
      avatar: yud,
      quote: "One small step today is better than a thousand plans tomorrow.",
    },
    {
      role: "Crewing Staff",
      name: "Aliefta Poetri Juniasih",
      education: "State Vocational High School 21 Jakarta, Indonesia",
      wa: "6288211903892",
      avatar: al,
      quote: "Keep chasing that dream until it becomes a reality.",
    },
    {
      role: "Crewing Staff",
      name: "Lia Dafri Naroly",
      education: "State Senior High School 72 Jakarta, Indonesia",
      wa: "628212972840",
      avatar: bul,
      quote: "The only way to do great work is to love what you do.",
    },
    {
      role: "Crewing Staff",
      name: "Breis Excelsis M., S.Ak.",
      education: "Paulus Christian University of Indonesia",
      wa: "6282299326734",
      avatar: breis,
      quote: "Fortis Fortuna Adiuvat.",
    },
  ],
};

const onboardCrew = [
  {
    position: "AB",
    vessel: "TANKER",
    status: "Onboard",
    nextPort: "CHINA",
    avatar: onboard1,
  },
  {
    position: "2O",
    vessel: "LCT",
    status: "Onboard",
    nextPort: "CHINA",
    avatar: onboard2,
  },
  {
    position: "AB",
    vessel: "BULK CARRIER",
    status: "Onboard",
    nextPort: "CHINA",
    avatar: onboard3,
  },
  {
    position: "3O",
    vessel: "VLCC",
    status: "Onboard",
    nextPort: "SINGAPORE",
    avatar: onboard4,
  },
  {
    position: "DECK CADET",
    vessel: "OIL TANKER",
    status: "Onboard",
    nextPort: "CHINA",
    avatar: onboard5,
  },
  {
    position: "AB & OILER ",
    vessel: "LCT",
    status: "Onboard",
    nextPort: "CHINA",
    avatar: onboard6,
  },
  {
    position: "CO",
    vessel: "GENERAL CARGO",
    status: "Onboard",
    nextPort: "KOREA",
    avatar: onboard7,
  },
  {
    position: "4E",
    vessel: "VLCC",
    status: "Onboard",
    nextPort: "SINGAPORE",
    avatar: onboard8,
  },
  {
    position: "CO & 3E & AB",
    vessel: "TUGBOAT",
    status: "Onboard",
    nextPort: "VIETNAM",
    avatar: onboard9,
  },
  {
    position: "AB & OILER & 2O",
    vessel: "GENERAL CARGO",
    status: "Onboard",
    nextPort: "CHINA",
    avatar: onboard10,
  },
  {
    position: "AB & OILER",
    vessel: "REFRIGERATED CARGO",
    status: "Onboard",
    nextPort: "BANGKOK",
    avatar: onboard11,
  },
  {
    position: "4E & OILER",
    vessel: "BULK CARRIER",
    status: "Onboard",
    nextPort: "CHINA",
    avatar: onboard12,
  },
];

// MemberCard Component
const MemberCard = ({ member, isMain = false, priority = false }) => (
  <div
    className={`group relative flex flex-col items-center text-center p-6 sm:p-8 bg-white/90 backdrop-blur-md rounded-[2.5rem] transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl ${
      isMain
        ? "max-w-4xl mx-auto shadow-2xl border-2 border-blue-100 ring-1 ring-blue-500/10"
        : "shadow-xl border border-slate-100/80 h-full hover:border-blue-200"
    }`}
  >
    {/* Avatar Frame */}
    <div
      className={`relative mb-6 overflow-hidden rounded-[2.2rem] transition-all duration-500 group-hover:scale-[1.02] ${
        isMain
          ? "w-72 h-72 sm:w-96 sm:h-96 shadow-2xl"
          : "w-60 h-60 sm:w-64 sm:h-64 shadow-lg"
      }`}
    >
      <img
        src={member.avatar}
        alt={member.name}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        style={{
          WebkitBackfaceVisibility: "hidden",
          transform: "translateZ(0)",
          imageRendering: "-webkit-optimize-contrast",
        }}
        loading={priority ? "eager" : "lazy"}
        decoding="sync"
      />
      {/* Floating WhatsApp Action Badge */}
      <a
        href={`https://wa.me/${member.wa}`}
        target="_blank"
        rel="noreferrer"
        aria-label={`Contact ${member.name} on WhatsApp`}
        className="absolute bottom-3 right-3 bg-emerald-500 text-white p-3.5 rounded-2xl shadow-lg hover:bg-emerald-600 transition-all hover:scale-110 z-10 group/wa flex items-center justify-center"
      >
        <MessageCircle
          size={22}
          className="group-hover/wa:rotate-12 transition-transform"
        />
      </a>
    </div>

    {/* Info & Content */}
    <div className="space-y-3.5 w-full text-center flex-1 flex flex-col justify-between">
      <div className="space-y-3">
        <div>
          <span className="inline-block text-[10px] sm:text-[11px] font-black uppercase tracking-[0.2em] text-blue-600 px-4 py-1.5 bg-blue-50/80 rounded-full border border-blue-100">
            {member.role}
          </span>
        </div>

        <h3
          className={`font-black text-slate-900 leading-tight tracking-tight ${
            isMain ? "text-2xl sm:text-4xl" : "text-xl sm:text-2xl"
          }`}
        >
          {member.name}
        </h3>

        <p className="text-slate-600 text-sm font-medium italic px-2 sm:px-4 leading-relaxed max-w-xl mx-auto">
          "{member.quote}"
        </p>
      </div>

      <div className="flex items-center justify-center gap-2 pt-4 border-t border-slate-100 text-slate-400">
        <GraduationCap size={16} className="text-blue-500 shrink-0" />
        <span className="text-[10px] sm:text-[11px] font-bold uppercase tracking-wider text-slate-500 line-clamp-2">
          {member.education}
        </span>
      </div>
    </div>
  </div>
);

const Team = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const crewRef = useRef(null);
  const itemsPerPage = 4;

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const totalPages = Math.ceil(onboardCrew.length / itemsPerPage);
  const currentCrew = onboardCrew.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const paginate = (page) => {
    setCurrentPage(page);
    if (crewRef.current) {
      window.scrollTo({
        top: crewRef.current.offsetTop - 100,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Seo title="Our Experts | PT Kamandanu Jaya Samudera" />
      <main
        className="bg-[#F8FAFC] min-h-screen text-slate-800"
        style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
      >
        {/* HERO SECTION */}
     {/* HERO SECTION */}
<section className="relative pt-28 sm:pt-32 pb-20 bg-[#0A2540] overflow-hidden">
  {/* Background Image dengan Overlay */}
  <div
    className="absolute inset-0 z-0 bg-cover bg-center"
    style={{ backgroundImage: `url(${backgroundImageHeader})` }}
  />
  <div className="absolute inset-0 bg-gradient-to-b from-[#0A2540]/80 via-[#0A2540]/90 to-[#0A2540]" />

  {/* Ambient Glow */}
  <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-blue-500/20 rounded-full blur-[120px] pointer-events-none z-0" />

  {/* Hero Content */}
  <div className="relative z-10 text-center text-white max-w-7xl mx-auto px-4">
    <div
      className={`transition-all duration-1000 ${
        isVisible
          ? "translate-y-0 opacity-100"
          : "translate-y-10 opacity-0"
      }`}
    >
      <h1 className="text-4xl md:text-6xl font-black text-white mb-6 drop-shadow-lg">
        Meet Our{" "}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-300 to-indigo-300">
          Great Team
        </span>
      </h1>

      <p className="text-xl text-blue-50/90 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
        Driving maritime excellence with professionalism, integrity, and
        world-class management expertise.
      </p>
    </div>
  </div>
</section>
        {/* HIERARCHY SECTION */}
        <div className="max-w-7xl mx-auto px-4 -mt-16 pb-24 relative z-20">
          <div className="flex flex-col items-center">
            {/* TIER 1: Owner */}
            <div
              className={`w-full transition-all duration-1000 delay-200 ${
                isVisible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-10 opacity-0"
              }`}
            >
              <MemberCard
                member={managementTeam.tier1[0]}
                isMain={true}
                priority={true}
              />
            </div>

            {/* TIER 2: Manager */}
            <div className="w-full max-w-2xl mt-10">
              <MemberCard member={managementTeam.tier2[0]} priority={true} />
            </div>

            {/* TIER 3: Crewing */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 w-full">
              {managementTeam.tier3.map((m, i) => (
                <MemberCard key={i} member={m} />
              ))}
            </div>

            {/* TIER 4: Crewing Staff */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-8 w-full">
              {managementTeam.tier4.map((m, i) => (
                <MemberCard key={i} member={m} />
              ))}
            </div>
          </div>
        </div>

        {/* TEAM PHOTO SECTION */}
        <section className="py-24 bg-white overflow-hidden border-t border-slate-100 relative">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-14">
              <span className="text-blue-600 font-black tracking-[0.3em] uppercase text-xs mb-3 block">
                The Power of Unity
              </span>
              <h2 className="text-3xl sm:text-5xl font-black text-slate-900 tracking-tight uppercase">
                United in Excellence
              </h2>
              <div className="h-1.5 w-20 bg-gradient-to-r from-blue-600 to-cyan-400 mx-auto mt-4 rounded-full" />
            </div>

            <div className="max-w-6xl mx-auto relative group">
              <div className="relative overflow-hidden rounded-[2.5rem] shadow-2xl border-4 sm:border-8 border-white">
                <img
                  src={allTeamPhoto}
                  alt="Management Team"
                  className="w-full h-auto object-cover transition-transform duration-1000 group-hover:scale-105"
                  style={{ imageRendering: "-webkit-optimize-contrast" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6 sm:p-12">
                  <div className="text-white">
                    <p className="flex items-center gap-2 font-bold uppercase tracking-widest text-xs sm:text-sm text-blue-300 mb-1 sm:mb-2">
                      <Camera size={18} /> Official Team Portrait
                    </p>
                    <h3 className="text-xl sm:text-3xl font-black tracking-tight">
                      PT. Kamandanu Jaya Samudera
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CREW REGISTRY */}
        <section
          ref={crewRef}
          className="bg-slate-50 py-24 border-t border-slate-100"
        >
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex flex-col lg:flex-row justify-between items-center mb-16 gap-8 text-slate-900">
              <div className="text-center lg:text-left">
                <span className="text-blue-600 font-bold tracking-[0.3em] uppercase text-xs mb-3 block">
                  Fleet Manpower
                </span>
                <h2 className="text-3xl sm:text-5xl font-black uppercase tracking-tight">
                  Active Personnel Highlights
                </h2>
              </div>

              <div className="flex items-center gap-5 bg-white p-5 sm:p-7 rounded-[2rem] shadow-xl border border-blue-50/80">
                <div className="w-14 h-14 bg-gradient-to-tr from-blue-600 to-indigo-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-500/20 shrink-0">
                  <Users className="text-white" size={26} />
                </div>
                <div>
                  <div className="text-2xl sm:text-3xl font-black text-slate-900 leading-tight">
                    7,000+
                  </div>
                  <div className="text-slate-400 text-[10px] font-bold uppercase tracking-widest mt-0.5">
                    Verified Seafarers Pool
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
              {currentCrew.map((crew, idx) => (
                <div
                  key={idx}
                  className="group bg-white rounded-[2.2rem] shadow-lg hover:shadow-2xl overflow-hidden border border-slate-100 transition-all duration-300 hover:-translate-y-1.5 flex flex-col justify-between"
                >
                  <div>
                    <div className="aspect-[4/5] overflow-hidden relative">
                      <img
                        src={crew.avatar}
                        alt={crew.position}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                        style={{ imageRendering: "-webkit-optimize-contrast" }}
                      />
                      <div className="absolute top-4 right-4 bg-emerald-500/90 backdrop-blur-md text-white text-[9px] font-black px-3 py-1 rounded-full uppercase tracking-widest shadow-md animate-pulse">
                        {crew.status}
                      </div>
                    </div>
                    <div className="p-6">
                      <h4 className="text-xl font-black text-slate-900 mb-1">
                        {crew.position}
                      </h4>
                      <p className="text-blue-600 text-xs font-bold uppercase tracking-widest">
                        {crew.vessel}
                      </p>
                    </div>
                  </div>

                  <div className="px-6 pb-6">
                    <div className="pt-4 border-t border-slate-100 flex justify-between items-center">
                      <span className="text-[10px] text-slate-400 font-black uppercase tracking-widest">
                        Destination
                      </span>
                      <span className="text-xs font-black text-blue-600 px-3 py-1 bg-blue-50 rounded-lg">
                        {crew.nextPort}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* PAGINATION */}
            <div className="flex justify-center items-center gap-4">
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous Page"
                className="w-12 h-12 rounded-2xl bg-white border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-blue-600 hover:text-white transition-all shadow-sm disabled:opacity-30 disabled:hover:bg-white disabled:hover:text-slate-600"
              >
                <ChevronLeft size={20} />
              </button>

              <div className="flex items-center gap-2">
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    onClick={() => paginate(i + 1)}
                    className={`w-11 h-11 rounded-2xl font-black text-sm transition-all ${
                      currentPage === i + 1
                        ? "bg-blue-600 text-white shadow-lg shadow-blue-500/25 scale-105"
                        : "bg-white text-slate-400 border border-slate-100 hover:bg-slate-50"
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>

              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next Page"
                className="w-12 h-12 rounded-2xl bg-white border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-blue-600 hover:text-white transition-all shadow-sm disabled:opacity-30 disabled:hover:bg-white disabled:hover:text-slate-600"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </section>

        {/* LIVE INSTAGRAM SHOWCASE SECTION */}
        <section className="py-20 bg-gradient-to-b from-slate-900 via-[#0A2540] to-slate-900 text-white relative overflow-hidden">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gradient-to-tr from-pink-500/10 via-purple-500/10 to-amber-500/10 rounded-full blur-3xl pointer-events-none" />

          <div className="max-w-4xl mx-auto px-4 relative z-10 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-amber-500/20 border border-pink-500/30 text-pink-300 text-xs font-black uppercase tracking-widest mb-6">
              <Sparkles size={14} /> Real-Time Deployment Gallery
            </div>

            <h2 className="text-3xl sm:text-5xl font-black text-white tracking-tight mb-4">
              Explore{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-pink-400 to-purple-400">
                1,000+ Crew Deployment
              </span>{" "}
              Records
            </h2>

            <p className="text-slate-300 text-base sm:text-lg leading-relaxed font-medium max-w-2xl mx-auto mb-10">
              Complete real-time documentation of crew departures, flights, and
              vessel operations is stored directly in our official Instagram
              highlights.
            </p>

            {/* Instagram Highlight Card */}
            <div className="max-w-md mx-auto mb-10">
              <a
                href="https://www.instagram.com/kamandanujayasamudera_/"
                target="_blank"
                rel="noreferrer"
                className="group block bg-white/5 hover:bg-white/10 backdrop-blur-md rounded-[2.5rem] p-8 border border-white/10 transition-all duration-300 hover:-translate-y-1 shadow-2xl hover:border-pink-500/40"
              >
                <div className="flex flex-col items-center">
                  <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full p-1.5 bg-gradient-to-tr from-amber-500 via-pink-500 to-purple-600 mb-5 shadow-2xl group-hover:scale-110 transition-transform duration-300">
                    <div className="w-full h-full bg-slate-900 rounded-full flex items-center justify-center border-4 border-slate-900">
                      <Instagram className="text-white" size={40} />
                    </div>
                  </div>

                  <span className="text-xs font-black tracking-[0.2em] text-pink-400 uppercase mb-1">
                    Featured Highlight
                  </span>
                  <h3 className="text-2xl sm:text-3xl font-black text-white group-hover:text-pink-300 transition-colors">
                    ON BOARD
                  </h3>
                  <p className="text-slate-400 text-sm font-semibold mt-1">
                    1,000+ Departures & Crew Documentation
                  </p>
                </div>
              </a>
            </div>

            {/* Direct Action Button */}
            <div>
              <a
                href="https://www.instagram.com/kamandanujayasamudera_/"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-3 px-8 py-4 sm:py-5 rounded-2xl bg-gradient-to-r from-pink-500 via-purple-600 to-indigo-600 hover:from-pink-600 hover:to-indigo-700 text-white font-black text-base shadow-2xl hover:shadow-pink-500/25 transition-all hover:scale-105"
              >
                <Instagram size={22} />
                <span>VIEW ON BOARD HIGHLIGHT ON INSTAGRAM</span>
                <ExternalLink size={18} />
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Team;
